<template>
  <div>
    <!--Container-->
    <el-container class="hx-template-container">
      <!--Header-->
      <el-header class="hx-template-header">
        <div class="hx-logo">
          <img src="static/images/logo-small.png" alt />
        </div>
        <div v-loading="headerLoading" class="headerMain">
          <!--Header Menu-->
          <el-menu :default-active="state.menuActive" @select="select" mode="horizontal" router>
            <el-menu-item v-for="item in menu" :index="item.path" :key="item.path" v-text="item.name" />

            <template v-if="stadiumHeader.length > 0">
              <el-submenu v-for="(item, index) in stadiumHeader" :index="item.stadiumUrl" :key="index">
                <template slot="title">{{ item.stadiumTitle }}</template>
                <el-menu-item v-for="val in submenuItem[index]" :index="val.path" :key="val.path" v-text="val.name" />
              </el-submenu>
            </template>
          </el-menu>
          <div class="hx-template-header-right">
            <p class="hx-account align-center">{{ username }}</p>

            <!-- <el-button type="text" @click="handleUpdatePwd">修改密码</el-button> -->

            <div class="login-out-style" @click="dialogVisible = true">
              <i class="el-icon-back"></i>
              <span>退出登录</span>
            </div>
          </div>
        </div>
      </el-header>

      <!--Container children-->
      <el-container style="height: 100%">
        <!--Aside-->
        <el-aside class="hx-template-aside">
          <!--Aside Menu-->
          <el-menu :unique-opened="true" @select="select" v-loading="sideLoading" :default-active="$route.path" v-if="sideBar" class="hx-aside-menu" router>
            <div v-for="(item, index) in sideBar" :key="index">
              <el-submenu v-if="sideBar[index].sub.length > 0" :index="item.path" :key="item.name">
                <template slot="title">{{ item.name }}</template>
                <el-menu-item v-for="val in item.sub" :index="val.path" :key="val.index">{{ val.name }}</el-menu-item>
              </el-submenu>
              <el-menu-item v-if="sideBar[index].sub.length === 0" :index="item.path" :key="item.name">
                <template slot="title">{{ item.name }}</template>
              </el-menu-item>
            </div>
          </el-menu>
        </el-aside>
        <!--Main-->
        <el-main class="hx-template-main">
          <transition name="fade" mode="out-in" appear>
            <!--Router View-->
            <router-view></router-view>
          </transition>
        </el-main>
      </el-container>
      <!--<el-footer class="hx-template-footer">-->
      <!--</el-footer>-->
    </el-container>

    <el-dialog class="hx-login-out-template" title="提示" :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="500px">
      <h3 class="align-center">确认退出服务加？</h3>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="linkToLoginPage">确 定</el-button>
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 修改密码弹窗 -->
    <PwdUpdate :dialogVisible.sync="dialogVisiblePwd" />
  </div>
</template>
<script>
import PwdUpdate from "./common/dialog/PwdUpdate.vue";

export default {
  components: { PwdUpdate },

  data() {
    return {
      state: {
        menu: [],
        menuActive: "",
      },
      submenu: [],
      submenuItem: [],
      stadiumHeader: [],
      sideBarActive: "",
      dialogVisible: false,
      headerLoading: false,
      sideLoading: false,
      username: "",
      dialogVisiblePwd: false,
    };
  },
  computed: {
    menu() {
      if (this.state.menu.length > 0) {
        const result = this.state.menu.map(val => {
          if (!val.submenu) {
            return {
              name: val.resourcesName,
              path: val.resourcesUrl,
            };
          } else {
            this.submenu = this.submenu.concat(val);
          }
        });
        result.map((item, index) => {
          if (item === undefined) {
            result.splice(index, 1);
          }
        });
        return result;
      } else {
        return [];
      }
    },
    menuActive() {
      // return this.state.menu[0].resourcesUrl;
      return "/" + this.$route.fullPath.split("/")[1];
    },
    sideBar() {
      let sideBarList = [];
      let resourceId = "";
      if (this.state.menu.length > 0) {
        const menuObj = this.state.menu.find(val => {
          const compareUrl = "/" + val.resourcesUrl.split("/")[1];
          return compareUrl === this.menuActive;
        });
        if (menuObj) {
          let arr = [];
          if (menuObj.submenu) {
            resourceId = parseInt(this.$route.params.stadiumType);
            if (resourceId) {
              arr = arr.concat(menuObj.submenu[0].childResourcesEntityList);
            }
          } else {
            arr = menuObj.childResourcesEntityList;
          }
          sideBarList = arr.map(val => ({
            name: val.resourcesName,
            path: val.childResourcesEntityList.length === 0 ? val.resourcesUrl : String(val.id),
            sub: val.childResourcesEntityList.map(val => ({
              name: val.resourcesName,
              path: String(val.resourcesUrl),
            })),
          }));
        }
      }
      // console.log(sideBarList);
      return sideBarList;
    },
  },

  methods: {
    /**
     * 菜单激活回调
     * @param val
     */
    select(val) {
      localStorage.setItem("active", val);
    },
    /**
     * 跳转至登录页
     */
    linkToLoginPage() {
      this.$router.push({
        name: "login",
      });
    },
    /**
     * 修改密码
     */
    handleUpdatePwd() {
      this.dialogVisiblePwd = true;
    },
  },

  created() {
    this.username = localStorage.getItem("username");
    this.headerLoading = true;
    this.sideLoading = true;
    this.$http({
      url: global.apiUrl + "/resource/entity",
      method: "GET",
    })
      .then(res => {
        this.headerLoading = false;
        this.sideLoading = false;
        if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
          this.state.menu = res.body.data;
          if (!localStorage.getItem("active")) {
            localStorage.setItem("active", this.state.menu[0].resourcesUrl);
          } else {
            localStorage.setItem("active", this.$route.fullPath);
          }
          this.$router.push({
            path: localStorage.getItem("active"),
          });
          this.state.menuActive = this.$route.fullPath;
        } else {
        }
      })
      .catch(err => {
        this.headerLoading = false;
        this.sideLoading = false;

        console.error(err);
      });

    // this.state.menuActive = this.$route.fullPath;
  },

  watch: {
    submenu(val, oldVal) {
      val.map(item => {
        this.stadiumHeader.push({
          stadiumTitle: item.resourcesName,
          stadiumUrl: item.resourcesUrl,
        });
        this.submenuItem.push(
          item.submenu.map(item1 => ({
            name: item1.resourcesName,
            path: item1.resourcesUrl,
          }))
        );
      });
    },
  },
};
</script>
<style lang="less" scoped>
.hx-template-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  .hx-template-header {
    padding: 0;
    display: flex;
    .hx-logo {
      width: 200px;
      height: 100%;
      float: left;
      position: relative;
      img {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
      }
    }
    .headerMain {
      flex: 1;
      position: relative;
    }
    .hx-template-header-right {
      position: absolute;
      right: 20px;
      top: 0;
      line-height: 60px;
      cursor: pointer;
      font-size: 14px;
      display: flex;
      .hx-account {
        margin-right: 10px;
        color: #333;
        // color: teal;
        // width: 100px;
        // overflow: hidden;
        // -ms-text-overflow: ellipsis;
        // text-overflow: ellipsis;
        // white-space: nowrap;
      }
      .login-out-style {
        margin-left: 10px;
        &:hover {
          color: teal;
        }
      }
    }
  }
  .hx-template-aside {
    height: 100%;
    width: 200px !important;
    .hx-aside-menu {
      height: 100%;
    }
  }
}

.hx-login-out-template {
  .el-dialog__footer {
    text-align: center;
  }
}
</style>
